<button mat-icon-button aria-label="Display mode" (click)="onClick($event)" [matTooltip]="(isDark() ? 'Dark' : 'Light') + ' mode'">
    <mat-icon>{{ isDark() ? iconDark : iconLight }}</mat-icon>
</button>